<template>
    <div>
        <div class="pc" id="queryresults" v-if="devicetype==1">
        <div class="home_top">
                <img class="image" src="../../assets/images/logo.png" alt="">
                <div class="home_title">国际打击乐协会证书查询</div>
            </div>
            <div class="enquiries_bottom"></div>
            <div class="enquiries_box">
                <div class="enquiers_box1">
                    查询结果
                </div>
            </div>
            <div v-if="type == 1" class="enquirers_box_list">
                <div class="enquirers_name">
                    <div class="enquirers_name_one">
                            <div class="enquirers_flex">
                                <span class="span1">姓名 /</span>
                                <span class="span2">Name</span>
                            </div>
                            <span class="span3">{{data.name}}</span>
                    </div>
                </div>
                <div class="enquirers_name">
                    <div class="enquirers_name_one">
                            <div class="enquirers_flex">
                                <span class="span1">会员编号 /</span>
                                <span class="span2">Membership number</span>
                            </div>
                            <span class="span3">{{data.number}}</span>
                    </div>
                </div>
                <div class="enquirers_name">
                    <div class="enquirers_name_one">
                            <div class="enquirers_flex">
                                <span class="span1">会员性质 /</span>
                                <span class="span2">Member grade</span>
                            </div>
                            <span class="span3">{{data.nature}}</span>
                    </div>
                </div>
                <div class="enquirers_name">
                    <div class="enquirers_name_one">
                            <div class="enquirers_flex">
                                <span class="span1">会员有效期 /</span>
                                <span class="span2">Validity</span>
                            </div>
                            <span class="span3">{{data.time}}</span>
                    </div>
                </div>
                <div class="enquirers_name">
                    <div class="enquirers_name_one">
                            <div class="enquirers_flex">
                                <span class="span1">身份证类型 /</span>
                                <span class="span2">ID type</span>
                            </div>
                            <span class="span3">{{data.id_card_type}}</span>
                    </div>
                </div>
                <div class="enquirers_name">
                    <div class="enquirers_name_one">
                            <div class="enquirers_flex">
                                <span class="span1">证件号 /</span>
                                <span class="span2">ID type</span>
                            </div>
                            <span class="span3">{{data.id_number}}</span>
                    </div>
                </div>
                <div v-if="data.honor!=''" class="enquirers_name">
                    <div class="enquirers_name_one">
                            <div class="enquirers_flex">
                                <span class="span1">特殊荣誉 /</span>
                                <span class="span2">Special honor</span>
                            </div>
                            <span class="span3">{{data.honor}}</span>
                    </div>
                </div>
            </div>
            <div v-if="type == 2" class="enquirers_box_list">
                <div class="enquirers_name">
                    <div class="enquirers_name_one">
                            <div class="enquirers_flex">
                                <span class="span1">姓名 /</span>
                                <span class="span2">Name</span>
                            </div>
                            <span class="span3">{{data.name}}</span>
                    </div>
                </div>
                <div class="enquirers_name">
                    <div class="enquirers_name_one">
                            <div class="enquirers_flex">
                                <span class="span1">教师编号 /</span>
                                <span class="span2">Teacher number</span>
                            </div>
                            <span class="span3">{{data.number}}</span>
                    </div>
                </div>
                <div class="enquirers_name">
                    <div class="enquirers_name_one">
                            <div class="enquirers_flex">
                                <span class="span1">教师等级 /</span>
                                <span class="span2">Teacher grade</span>
                            </div>
                            <span class="span3">{{data.grade}}</span>
                    </div>
                </div>
                <div class="enquirers_name">
                    <div class="enquirers_name_one">
                            <div class="enquirers_flex">
                                <span class="span1">官方考核成绩 /</span>
                                <span class="span2">Examination result</span>
                            </div>
                            <span class="span3">{{data.achievement}}</span>
                    </div>
                </div>
                <div class="enquirers_name">
                    <div class="enquirers_name_one">
                            <div class="enquirers_flex">
                                <span class="span1">教师资格有效期 /</span>
                                <span class="span2">Validity</span>
                            </div>
                            <span class="span3">{{data.time}}</span>
                    </div>
                </div>
                <div class="enquirers_name">
                    <div class="enquirers_name_one">
                            <div class="enquirers_flex">
                                <span class="span1">身份证类型 /</span>
                                <span class="span2">ID type</span>
                            </div>
                            <span class="span3">{{data.id_card_type}}</span>
                    </div>
                </div>
                <div class="enquirers_name">
                    <div class="enquirers_name_one">
                            <div class="enquirers_flex">
                                <span class="span1">证件号 /</span>
                                <span class="span2">ID No</span>
                            </div>
                            <span class="span3">{{data.id_number}}</span>
                    </div>
                </div>
                <div v-if="data.honor!=''" class="enquirers_name">
                    <div class="enquirers_name_one">
                            <div class="enquirers_flex">
                                <span class="span1">特殊荣誉 /</span>
                                <span class="span2">Special honor</span>
                            </div>
                            <span class="span3">{{data.honor}}</span>
                    </div>
                </div>
                <div v-if="data.certification_body!=''" class="enquirers_name">
                    <div class="enquirers_name_one">
                            <div class="enquirers_flex">
                                <span class="span1">认证机构 /</span>
                                <span class="span2">Certification author</span>
                            </div>
                            <span class="span3">{{data.certification_body}}</span>
                    </div>
                </div>
            </div>
            <div v-if="type == 3" class="enquirers_box_list">
                <div class="enquirers_name">
                    <div class="enquirers_name_one">
                            <div class="enquirers_flex">
                                <span class="span1">姓名 /</span>
                                <span class="span2">Name</span>
                            </div>
                            <span class="span3">{{data.name}}</span>
                    </div>
                </div>
                <div class="enquirers_name">
                    <div class="enquirers_name_one">
                            <div class="enquirers_flex">
                                <span class="span1">基本功等级 /</span>
                                <span class="span2">Rudiments grade</span>
                            </div>
                            <span class="span3">{{data.basic_skill_grade}}</span>
                    </div>
                </div>
                <div class="enquirers_name">
                    <div class="enquirers_name_one">
                            <div class="enquirers_flex">
                                <span class="span1">基本功等级证书编号 /</span>
                                <span class="span2">Certification number（Rudiments）</span>
                            </div>
                            <span class="span3">{{data.basic_skill_number}}</span>
                    </div>
                </div>
                <div class="enquirers_name">
                    <div class="enquirers_name_one">
                            <div class="enquirers_flex">
                                <span class="span1">演奏等级 /</span>
                                <span class="span2">Performance grade</span>
                            </div>
                            <span class="span3">{{data.play_grade}}</span>
                    </div>
                </div>
                <div class="enquirers_name">
                    <div class="enquirers_name_one">
                            <div class="enquirers_flex">
                                <span class="span1">演奏等级证书编号 /</span>
                                <span class="span2">Certification number（Performance）</span>
                            </div>
                            <span class="span3">{{data.play_number}}</span>
                    </div>
                </div>
                <div class="enquirers_name">
                    <div class="enquirers_name_one">
                            <div class="enquirers_flex">
                                <span class="span1">身份证类型 /</span>
                                <span class="span2">ID type</span>
                            </div>
                            <span class="span3">{{data.id_card_type}}</span>
                    </div>
                </div>
                <div class="enquirers_name">
                    <div class="enquirers_name_one">
                            <div class="enquirers_flex">
                                <span class="span1">证件号 /</span>
                                <span class="span2">ID No</span>
                            </div>
                            <span class="span3">{{data.id_number}}</span>
                    </div>
                </div>
                <div class="enquirers_name">
                    <div class="enquirers_name_one">
                            <div class="enquirers_flex">
                                <span class="span1">基本功考核成绩 /</span>
                                <span class="span2">Examination result（Rudiments）</span>
                            </div>
                            <span class="span3">{{data.basic_skill_achievement}}</span>
                    </div>
                </div>
                <div v-if="data.play_achievement!=''" class="enquirers_name">
                    <div class="enquirers_name_one">
                            <div class="enquirers_flex">
                                <span class="span1">演奏考核成绩 /</span>
                                <span class="span2">Examination result（Performance）</span>
                            </div>
                            <span class="span3">{{data.play_achievement}}</span>
                    </div>
                </div>
                <div v-if="data.honor!=''" class="enquirers_name">
                    <div class="enquirers_name_one">
                            <div class="enquirers_flex">
                                <span class="span1">特殊荣誉 /</span>
                                <span class="span2">Special honor</span>
                            </div>
                            <span class="span3">{{data.honor}}</span>
                    </div>
                </div>
            </div>

            <div v-if="type == 4" class="enquirers_box_list">
                <div class="enquirers_name">
                    <div class="enquirers_name_one">
                            <div class="enquirers_flex">
                                <span class="span1">姓名 /</span>
                                <span class="span2">Name</span>
                            </div>
                            <span class="span3">{{data.name}}</span>
                    </div>
                </div>
                <div class="enquirers_name">
                    <div class="enquirers_name_one">
                            <div class="enquirers_flex">
                                <span class="span1">证书编号 /</span>
                                <span class="span2">Certification number </span>
                            </div>
                            <span class="span3">{{data.number}}</span>
                    </div>
                </div>
                <div class="enquirers_name">
                    <div class="enquirers_name_one">
                            <div class="enquirers_flex">
                                <span class="span1">赛事名称 /</span>
                                <span class="span2">Competition Name</span>
                            </div>
                            <span class="span3">{{data.game_name}}</span>
                    </div>
                </div>
                <div class="enquirers_name">
                    <div class="enquirers_name_one">
                            <div class="enquirers_flex">
                                <span class="span1">奖项成绩 /</span>
                                <span class="span2">Award results</span>
                            </div>
                            <span class="span3">{{data.achievement}}</span>
                    </div>
                </div>
            </div>


            <div class="bottombar" style="bottom:120px">IPA国际打击乐协会&nbsp;<a href="https://beian.miit.gov.cn" target="_blank">浙ICP备2022004148号-1</a>&nbsp;china@ipa.work</div>
        </div>
        
        <div class="queryresults phone" v-if="devicetype==0">
            <div style="min-height:calc(100vh - 60px);overflow-y:auto">
                <div class="membership_sh">
                    <div v-if="type == 1" class="mem_top1">
                        查询结果
                    </div>
                    <div v-if="type == 2" class="mem_top2">
                        查询结果
                    </div>
                    <div v-if="type == 3" class="mem_top3">
                        查询结果
                    </div>
                    <div v-if="type == 4" class="mem_top4">
                        查询结果
                    </div>
                </div>
                <div v-if="type==1">
                    <div class="center_box">
                        <div class="flex center_box_cx">
                            <div class="center_title_flex">
                                <div class="center_title">
                                    姓名
                                </div>
                                <div class="center_title1">
                                    Name
                                </div>
                            </div>
                            <div class="center_flex_title2">
                                <div class="input">
                                    {{data.name}}
                                </div>
                            </div>
                        </div>
                        <div class="">
                            
                        </div>
                    </div>
                    <div class="center_box">
                        <div class="flex center_box_cx">
                            <div class="center_title_flex">
                                <div class="center_title">
                                    会员编号
                                </div>
                                <div class="center_title1">
                                    Membership number
                                </div>
                            </div>
                            <div class="center_flex_title2">
                                <div class="input">
                                    {{data.number}}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="center_box">
                        <div class="flex center_box_cx">
                            <div class="center_title_flex">
                                <div class="center_title">
                                    会员性质
                                </div>
                                <div class="center_title1">
                                    Member grade
                                </div>
                            </div>
                            <div class="center_flex_title2">
                                <div class="input">
                                    {{data.nature}}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="center_box">
                        <div class="flex center_box_cx">
                            <div class="center_title_flex">
                                <div class="center_title">
                                    会员有效期
                                </div>
                                <div class="center_title1">
                                    Validity
                                </div>
                            </div>
                            <div class="center_flex_title2">
                                <div class="input">
                                    {{data.time}}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="center_box">
                        <div class="flex center_box_cx">
                            <div class="center_title_flex">
                                <div class="center_title">
                                    身份证类型
                                </div>
                                <div class="center_title1">
                                    ID type
                                </div>
                            </div>
                            <div class="center_flex_title2">
                                <div class="input">
                                    {{data.id_card_type}}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="center_box">
                        <div class="flex center_box_cx">
                            <div class="center_title_flex">
                                <div class="center_title">
                                    证件号
                                </div>
                                <div class="center_title1">
                                    ID No
                                </div>
                            </div>
                            <div class="center_flex_title2">
                                <div class="input">
                                    {{data.id_number}}
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- <div v-if="data.honor!=''" class="center_box padding-tb-10" style="height: auto">
                        <div class="flex center_box_cx">
                            <div class="center_title_flex" style="flex-shrink: 0;">
                                <div class="center_title">
                                    特殊荣誉
                                </div>
                                <div class="center_title1">
                                    Special honor
                                </div>
                            </div>
                            <div class="flex-one text-right padding-lr-30">
                                <div class="input">
                                    <div class="margin-bottom-5">data.honor</div>
                                    <div class="margin-bottom-5" v-for="(item,index) in data.honor" :key="index">{{item}}</div>
                                </div>
                            </div>
                        </div>
                    </div> -->
                    <div class="flex padding-tb-18 padding-lr-15 bb_cc" :class="data.honor.length==1?'align-center':''" v-if="data.honor&&data.honor.length">
                        <div>
                            <div class="text-4d fs_28">特殊荣誉</div>
                            <div class="text-98 fs_20">Special honor</div>
                        </div>
                        <div class="flex-one text-right fs_28 padding-left-15">
                            <div class="">
                                <!-- <div class="margin-bottom-5">data.honor</div> -->
                                <div class="margin-bottom-5" v-for="(item,index) in data.honor" :key="index">{{item}}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="type==2">
                    <div class="center_box">
                        <div class="flex center_box_cx">
                            <div class="center_title_flex">
                                <div class="center_title">
                                    姓名
                                </div>
                                <div class="center_title1">
                                    Name
                                </div>
                            </div>
                            <div class="center_flex_title2">
                                <div class="input">
                                    {{data.name}}
                                </div>
                            </div>
                        </div>
                        <div class="">
                            
                        </div>
                    </div>
                    <div class="center_box">
                        <div class="flex center_box_cx">
                            <div class="center_title_flex">
                                <div class="center_title">
                                    教师编号
                                </div>
                                <div class="center_title1">
                                    Teacher number
                                </div>
                            </div>
                            <div class="center_flex_title2">
                                <div class="input">
                                    {{data.number}}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="center_box">
                        <div class="flex center_box_cx">
                            <div class="center_title_flex">
                                <div class="center_title">
                                    教师等级
                                </div>
                                <div class="center_title1">
                                    Teacher grade
                                </div>
                            </div>
                            <div class="center_flex_title2">
                                <div class="input">
                                    {{data.grade}}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="center_box">
                        <div class="flex center_box_cx">
                            <div class="center_title_flex">
                                <div class="center_title">
                                    官方考核成绩
                                </div>
                                <div class="center_title1">
                                    Examination result
                                </div>
                            </div>
                            <div class="center_flex_title2">
                                <div class="input">
                                    {{data.achievement}}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="center_box">
                        <div class="flex center_box_cx">
                            <div class="center_title_flex">
                                <div class="center_title">
                                    教师资格有效期
                                </div>
                                <div class="center_title1">
                                    Validity
                                </div>
                            </div>
                            <div class="center_flex_title2">
                                <div class="input">
                                    {{data.time}}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="center_box">
                        <div class="flex center_box_cx">
                            <div class="center_title_flex">
                                <div class="center_title">
                                    身份证类型
                                </div>
                                <div class="center_title1">
                                    ID type
                                </div>
                            </div>
                            <div class="center_flex_title2">
                                <div class="input">
                                    {{data.id_card_type}}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="center_box">
                        <div class="flex center_box_cx">
                            <div class="center_title_flex">
                                <div class="center_title">
                                    证件号
                                </div>
                                <div class="center_title1">
                                    ID No
                                </div>
                            </div>
                            <div class="center_flex_title2">
                                <div class="input">
                                    {{data.id_number}}
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- <div v-if="data.honor!=''" class="center_box">
                        <div class="flex center_box_cx">
                            <div class="center_title_flex">
                                <div class="center_title">
                                    特殊荣誉
                                </div>
                                <div class="center_title1">
                                    Special honor
                                </div>
                            </div>
                            <div class="center_flex_title2">
                                <div class="input">
                                    {{data.honor}}
                                </div>
                            </div>
                        </div>
                    </div> -->
                    <div class="flex padding-tb-18 padding-lr-15 bb_cc" :class="data.honor.length==1?'align-center':''" v-if="data.honor&&data.honor.length">
                        <div>
                            <div class="text-4d fs_28">特殊荣誉</div>
                            <div class="text-98 fs_20">Special honor</div>
                        </div>
                        <div class="flex-one text-right fs_28 padding-left-15">
                            <div class="">
                                <!-- <div class="margin-bottom-5">data.honor</div> -->
                                <div class="margin-bottom-5" v-for="(item,index) in data.honor" :key="index">{{item}}</div>
                            </div>
                        </div>
                    </div>
                    <div v-if="data.certification_body!=''" class="center_box">
                        <div class="flex center_box_cx">
                            <div class="center_title_flex">
                                <div class="center_title">
                                    认证机构
                                </div>
                                <div class="center_title1">
                                    Certification author
                                </div>
                            </div>
                            <div class="center_flex_title2">
                                <div class="input">
                                    {{data.certification_body}}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="type==3">
                    <div class="center_box">
                        <div class="flex center_box_cx">
                            <div class="center_title_flex">
                                <div class="center_title">
                                    姓名
                                </div>
                                <div class="center_title1">
                                    Name
                                </div>
                            </div>
                            <div class="center_flex_title2">
                                <div class="input">
                                    {{data.name}}
                                </div>
                            </div>
                        </div>
                        <div class="">
                            
                        </div>
                    </div>
                    <div class="center_box">
                        <div class="flex center_box_cx">
                            <div class="center_title_flex">
                                <div class="center_title">
                                    基本功等级
                                </div>
                                <div class="center_title1">
                                    Rudiments grade
                                </div>
                            </div>
                            <div class="center_flex_title2">
                                <div class="input">
                                    {{data.basic_skill_grade}}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="center_box">
                        <div class="flex center_box_cx">
                            <div class="center_title_flex">
                                <div class="center_title">
                                    基本功等级证书编号
                                </div>
                                <div class="center_title1">
                                    Certification number（Rudiments）
                                </div>
                            </div>
                            <div class="center_flex_title2">
                                <div class="input">
                                    {{data.basic_skill_number}}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="center_box">
                        <div class="flex center_box_cx">
                            <div class="center_title_flex">
                                <div class="center_title">
                                    演奏等级
                                </div>
                                <div class="center_title1">
                                    Performance grade
                                </div>
                            </div>
                            <div class="center_flex_title2">
                                <div class="input">
                                    {{data.play_grade}}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="center_box">
                        <div class="flex center_box_cx">
                            <div style="width: 50%;" class="center_title_flex">
                                <div class="center_title5">
                                    演奏等级证书编号
                                </div>
                                <div class="center_title1">
                                    Certification number（Performance）
                                </div>
                            </div>
                            <div class="center_flex_title2">
                                <div class="input">
                                    {{data.play_number}}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="center_box">
                        <div class="flex center_box_cx">
                            <div class="center_title_flex">
                                <div class="center_title">
                                    身份证类型
                                </div>
                                <div class="center_title1">
                                    ID type
                                </div>
                            </div>
                            <div class="center_flex_title2">
                                <div class="input">
                                    {{data.id_card_type}}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="center_box">
                        <div class="flex center_box_cx">
                            <div class="center_title_flex">
                                <div class="center_title">
                                    证件号
                                </div>
                                <div class="center_title1">
                                    ID No
                                </div>
                            </div>
                            <div class="center_flex_title2">
                                <div class="input">
                                    {{data.id_number}}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="center_box">
                        <div class="flex center_box_cx">
                            <div class="center_title_flex">
                                <div class="center_title">
                                    基本功考核成绩
                                </div>
                                <div class="center_title1">
                                    Examination result（Rudiments）
                                </div>
                            </div>
                            <div class="center_flex_title2">
                                <div class="input">
                                    {{data.basic_skill_achievement}}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="data.play_achievement!=''" class="center_box">
                        <div class="flex center_box_cx">
                            <div class="center_title_flex">
                                <div class="center_title">
                                    演奏考核成绩
                                </div>
                                <div class="center_title1">
                                    Examination result（Performance）
                                </div>
                            </div>
                            <div class="center_flex_title2">
                                <div class="input">
                                    {{data.play_achievement}}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="flex padding-tb-18 padding-lr-15 bb_cc" :class="data.honor.length==1?'align-center':''" v-if="data.honor&&data.honor.length">
                        <div>
                            <div class="text-4d fs_28">特殊荣誉</div>
                            <div class="text-98 fs_20">Special honor</div>
                        </div>
                        <div class="flex-one text-right fs_28 padding-left-15">
                            <div class="">
                                <!-- <div class="margin-bottom-5">data.honor</div> -->
                                <div class="margin-bottom-5" v-for="(item,index) in data.honor" :key="index">{{item}}</div>
                            </div>
                        </div>
                    </div>
                    <!-- <div v-if="data.honor!=''" class="center_box">
                        <div class="flex center_box_cx">
                            <div class="center_title_flex">
                                <div class="center_title">
                                    特殊荣誉
                                </div>
                                <div class="center_title1">
                                    Special honor
                                </div>
                            </div>
                            <div class="center_flex_title2">
                                <div class="input">
                                    {{data.honor}}
                                </div>
                            </div>
                        </div>
                    </div> -->
                </div>

                <div v-if="type==4">
                    <div class="center_box">
                        <div class="flex center_box_cx">
                            <div class="center_title_flex">
                                <div class="center_title">
                                    姓名
                                </div>
                                <div class="center_title1">
                                    Name
                                </div>
                            </div>
                            <div class="center_flex_title2">
                                <div class="input">
                                    {{data.name}}
                                </div>
                            </div>
                        </div>
                        <div class=""></div>
                    </div>

                    <div class="center_box">
                        <div class="flex center_box_cx">
                            <div class="center_title_flex">
                                <div class="center_title">
                                    证书编号
                                </div>
                                <div class="center_title1">
                                Certification number
                                </div>
                            </div>
                            <div class="center_flex_title2">
                                <div class="input">
                                    {{data.number}}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="center_box">
                        <div class="flex center_box_cx">
                            <div class="center_title_flex">
                                <div class="center_title">
                                    赛事名称
                                </div>
                                <div class="center_title1">
                                    Competition Name
                                </div>
                            </div>
                            <div class="center_flex_title2">
                                <div class="input">
                                    {{data.game_name}}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="center_box">
                        <div class="flex center_box_cx">
                            <div class="center_title_flex">
                                <div class="center_title">
                                    奖项成绩
                                </div>
                                <div class="center_title1">
                                    Award results
                                </div>
                            </div>
                            <div class="center_flex_title2">
                                <div class="input">
                                    {{data.achievement}}
                                </div>
                            </div>
                        </div>
                    </div>

                </div> </div>
                <div class="padding-tb-20 text-center">IPA国际打击乐协会&nbsp;<a href="https://beian.miit.gov.cn" target="_blank">浙ICP备2022004148号-1</a>&nbsp;china@ipa.work</div>

        </div>
    </div>
</template>

<script>
export default {
    data(){
        return{
            type:null,
            data:{},
            devicetype:''
        }
    },
    created(){
        this.type = this.$route.query.type
        this.data = this.$route.query.data
        console.log(this.data)
        this.loadDeviceType();
    },
    methods:{
         // 看是手机端还是pc端
        loadDeviceType() {
            if ((navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|wOSBrowser|BrowserNG|WebOS)/i))) {
               this.devicetype = 0
            }
            else {
                this.devicetype = 1
            }
        }
    }
}
</script>

<style scoped>
#queryresults{
    min-height: 100vh;
    background: #FFFFFF;
}
.pc .home_top{
    width: 100%;
    height: 120px;
    background: #4D4D4D;
    /* background: #fff; */
    display: flex;
    align-items: center;
}

.pc .image{
    /* 922*255 */
    /* width: 238px; */
    margin-left: 360px;
    height: 74px;
    width: 267px;
}

.pc .home_title{
    font-size: 26px;
    font-weight: 600;
    color: #FFFFFF;
    margin-left: 500px;
}
.pc .enquiries_bottom{
    width: 100%;
    height: 120px;
    background: #4D4D4D;
    position: fixed;
    bottom: 0;
    left: 0;
}
.pc .enquiries_box{
    margin-left: 260px;
    margin-right: 260px;
    border-bottom: solid 1px #979797;
}
.pc .enquiers_box1{
    height: 82px;
    line-height: 82px;
    font-size: 18px;
    color: #4D4D4D;
    margin-left: 150px;
}
.pc .enquirers_box_list{
    margin-left: 482px;
    margin-top: 31px;
}

.pc .enquirers_name_one{
     margin-top: 30px;
     display: flex;
}
.pc .enquirers_flex{
    width: 300px;
}
.pc .span1{
    font-size: 16px;
    font-weight: 400;
    color: #4D4D4D;
}
.pc .span2{
    font-size: 12px;
    font-weight: 300;
    color: #989898;
}
.pc .span3{
    margin-left: 200px;
}

.queryresults{
    min-height: 100vh;
    background: #fff;
}
.phone .mem_top1{
    width: 100%;
    height: 100px;
    background: #0BC8E8;
    font-size: 38px;
    font-weight: 600;
    color: #FFFFFF;
    line-height:100px;
    text-align:center;
}
.phone .mem_top2{
    width: 100%;
    height: 100px;
    background: #FAA51F;
    font-size: 38px;
    font-weight: 600;
    color: #FFFFFF;
    line-height:100px;
    text-align:center;
}
.phone .mem_top3{
    width: 100%;
    height: 100px;
    background: #FF5467;
    font-size: 38px;
    font-weight: 600;
    color: #FFFFFF;
    line-height:100px;
    text-align:center;
}
.phone .mem_top4{
    width: 100%;
    height: 100px;
    background: #B375FF;
    font-size: 38px;
    font-weight: 600;
    color: #FFFFFF;
    line-height:100px;
    text-align:center;
}
.phone .center_title{
    font-size: 28px;
    font-weight: 400;
    color: #4D4D4D;
    margin-left: 30px;
    padding-top:32px;
}
.phone .center_title5{
    font-size: 28px;
    font-weight: 400;
    color: #4D4D4D;
    margin-left: 30px;
    padding-top:32px;
}
.phone .center_title1{
    font-size: 20px;
    font-weight: 300;
    color: #989898;
    margin-left: 29px;
}
.phone .center_box_cx{
    display: flex;
}
.phone .center_box{
    height: 128px;
    border-bottom: 1px solid #CCCCCC;
}
.phone .center_flex_title2{
    margin-left: auto;
    text-align: right;
    margin-right: 30px;
    font-size: 28px;
    margin-top: 54px;
}
.phone .input{
    font-size: 28px;
    font-weight: 400;
    color: #4D4D4D;
}
.phone .bb_cc{
    border-bottom:1px solid #ccc
}
.margin-bottom-5{
    margin-bottom:5px
}
.padding-tb-18{
    padding-top: 35px;
    padding-bottom:35px
}
</style>


// WEBPACK FOOTER //
// src/pages/queryresults/queryresults.vue